import Tbid from "th/tbid";

export { Tbid };

customElements.define("th-tbid", Tbid.CustomElementConstructor);
